export const ANALYTICS_TRACKING_SCREEN = 'logIn'
